import { HTMLAttributes } from 'react';
export interface StatBlockGridData {
  value: string;
  valueText?: string;
  total?: string;
}

export interface StatBlockGridComponentProps {
  data: StatBlockGridData[];
  label?: string;
  subLabel?: string;
  loading?: boolean;
}

export type StatBlockGridProps = StatBlockGridComponentProps & HTMLAttributes<HTMLDivElement>;
